<template>
  <div class="screen-2">
    <div class="inner">
      <div class="top">商品百科</div>
      <div
        class="middle"
      >在商品百科模块，您可以了解到永辉的商品在田野湖泊的种养殖环境、生长周期、加工流程、存储方式，探索商品背后的故事，饕餮食客们还可以发掘商品的品鉴烹饪方法。</div>
      <div class="bottom">
        <div class="item">
          <img src="@/assets/干货.png" alt />
          <div>干货</div>
        </div>
        <div class="item">
          <img src="@/assets/水果.png" alt />
          <div>水果</div>
        </div>
        <div class="item">
          <img src="@/assets/蔬菜.png" alt />
          <div>蔬菜</div>
        </div>
        <div class="item">
          <img src="@/assets/家禽.png" alt />
          <div>家禽</div>
        </div>
        <div class="item">
          <img src="@/assets/猪肉.png" alt />
          <div>猪肉</div>
        </div>
        <div class="item">
          <img src="@/assets/冻鲜.png" alt />
          <div>冻鲜</div>
        </div>
        <div class="item">
          <img src="@/assets/贝类.png" alt />
          <div>贝类</div>
        </div>
        <div class="item">
          <img src="@/assets/活鲜.png" alt />
          <div>活鲜</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Screen from "./Screen";
export default {
  name: "Screen2",
  extends: Screen,
  data() {
    return {
      id: 2
    };
  }
};
</script>

<style lang="scss">
.screen-2 {
  .inner {
    width: 1200px;
    z-index: 3;
    .top {
      text-align: center;
      font-size: 56px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
    }

    .middle {
      margin-top: 50px;
      margin-bottom: 100px;
      text-align: center;
      font-size: 24px;
      font-weight: 200;
      color: rgba(255, 255, 255, 1);
      line-height: 42px;
    }

    .bottom {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      .item {
        width: 130px;

        img {
          width: 130px;
          border-radius: 50%;
        }

        div {
          margin-top: 15px;
          text-align: center;
          font-size: 25px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}
</style>